<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Job Title {{filterWithEmployeeAttribute && filterWithEmployeeAttribute?.jobTitle ? '*': ''}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container" *ngFor="let jobTitle of employeeService.allJobTitles">
            {{jobTitle}}
            <mat-checkbox (change)="onSelectEmployeeAttribute('jobTitle', jobTitle, $event.checked)">
            </mat-checkbox>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Department {{filterWithEmployeeAttribute && filterWithEmployeeAttribute?.department ? '*': ''}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container" *ngFor="let department of employeeService.allDepartments">
            {{department}}
            <mat-checkbox (change)="onSelectEmployeeAttribute('department', department, $event.checked)">
            </mat-checkbox>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Company {{filterWithEmployeeAttribute && filterWithEmployeeAttribute?.company ? '*': ''}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container" *ngFor="let company of employeeService.allCompanies">
            {{company}}
            <mat-checkbox (change)="onSelectEmployeeAttribute('company', company, $event.checked)"></mat-checkbox>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Location {{filterWithEmployeeAttribute && filterWithEmployeeAttribute?.location ? '*': ''}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container" *ngFor="let location of employeeService.allLocations">
            {{location}}
            <mat-checkbox (change)="onSelectEmployeeAttribute('location', location, $event.checked)"></mat-checkbox>
        </div>
    </mat-expansion-panel>
</mat-accordion>

<mat-accordion>
    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Gender {{filterWithEmployeeAttribute && filterWithEmployeeAttribute?.gender ? '*': ''}}
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="checkbox-container" *ngFor="let gender of employeeService.allGenders">
            {{gender}}
            <mat-checkbox (change)="onSelectEmployeeAttribute('gender', gender, $event.checked)"></mat-checkbox>
        </div>
    </mat-expansion-panel>
</mat-accordion>